module.exports = "<div class=\"progress\"\r\n     *ngIf=\"isSpinnerVisible\">\r\n  <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n</div>\r\n"